import _ from "lodash/fp.js";
import { useState } from "react";
const useUniqueId = (prefix = "element") => {
  const [uniqueId] = useState(() => _.uniqueId(""));
  return `${prefix}-${uniqueId}`;
};
export {
  useUniqueId
};
